export class MentionDeletedEvent extends Event {
  public userId: string;
}
